"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RtfTableCellController = void 0;
var list_1 = require("@devexpress/utils/lib/utils/list");
var rtf_table_cell_1 = require("../model/table/rtf-table-cell");
var RtfTableCellController = (function () {
    function RtfTableCellController(rowController) {
        this.rowController = rowController;
    }
    RtfTableCellController.prototype.startNewCell = function () {
        var row = this.rowController.currentRow;
        this.currentCell = new rtf_table_cell_1.RtfTableCell(row);
    };
    RtfTableCellController.prototype.isCurrentCellNotComplete = function () {
        var _this = this;
        return !list_1.ListUtils.elementBy(this.rowController.currentRow.cells, function (v) { return v == _this.currentCell; }) && !this.currentCell.isEmpty;
    };
    RtfTableCellController.prototype.assignLastCellAsCurrent = function () {
        this.currentCell = list_1.ListUtils.last(this.rowController.currentRow.cells);
    };
    RtfTableCellController.prototype.finishCell = function () {
        var cells = this.rowController.currentRow.cells;
        if (cells.length == 0 || list_1.ListUtils.last(cells) != this.currentCell) {
            this.currentCell.index = cells.length;
            cells.push(this.currentCell);
        }
    };
    RtfTableCellController.prototype.setCharacterInterval = function (interval) {
        this.setIntervalCore(this.currentCell, interval);
        this.setParagraphIntervalToParentCell(interval);
    };
    RtfTableCellController.prototype.setParagraphIntervalToParentCell = function (interval) {
        var parentCell = this.rowController.tableController.currentTable.parentCell;
        while (parentCell != null) {
            this.setIntervalCore(parentCell, interval);
            parentCell = parentCell.row.table.parentCell;
        }
    };
    RtfTableCellController.prototype.setIntervalCore = function (cell, interval) {
        if (cell.startPos < 0)
            cell.startPos = interval.start;
        cell.endPos = interval.end;
    };
    RtfTableCellController.prototype.reset = function () {
        this.currentCell = null;
    };
    return RtfTableCellController;
}());
exports.RtfTableCellController = RtfTableCellController;
